export default __webpack_public_path__ + "static/media/category-icon-Placeholder.4817e818.svg";